const siteUrl = "https://ronyarnet.gatsbyjs.io";

export default (slug) =>
  slug == null ? null : `${siteUrl}/${slug.replace(/^\//, "")}`;
